module.exports = __webpack_public_path__ + "images/assets/a8634ac6fbb4d12ba5a0ac517462784f.svg";